var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "step-indicator"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 5,
    cy: 5,
    r: 5,
    fill: "#BFA7A9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepIndicator);
export default __webpack_public_path__ + "static/media/step-indicator.5d85ff3ebfb30e4512abe69273af6dd1.svg";
export { ForwardRef as ReactComponent };